import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';

import { GeoCoderControl } from './geo-coder-control';
import { Util } from '../../util';
import  Map from '../../map';

export class GeoCoderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            provider: undefined,
            key: undefined
        };
        this.events = {
            'place_changed': undefined
        };
    }
    render() {
        return (React.createElement("div", null, this.props.children));
    }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new GeoCoderControl(options);
        this.geoCoder = this.control.geoCoder;
        this.context.mapComp.controls.push(this.control);
        this.geoCoder = this.control.geoCoder;
        //regitster events
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
GeoCoderComponent['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};